// extracted by mini-css-extract-plugin
module.exports = {"cell":"_b2df863","cellExpand":"_4ae030a","cellIcon":"_c86c739","cellStartStateLateReg":"_0010649","cellName":"_4da71d0","cellPrizePool":"_e80ffc6"};